import React, { useEffect, useMemo, useState } from 'react';

const API_URL = 'https://appcorp.parma.com.gt/apipp/ReceptorDatos';
const TOKEN = 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY';

const pageStyles = {
  container: {
    minHeight: '100vh',
    background: '#f4f7f8',
    padding: '24px',
    fontFamily: 'Arial, sans-serif',
    color: '#172536'
  },
  wrapper: {
    maxWidth: '1280px',
    margin: '0 auto'
  },
  header: {
    background: '#fff',
    borderRadius: '8px',
    padding: '22px 26px',
    boxShadow: '0 2px 10px rgba(18, 38, 63, 0.08)',
    marginBottom: '18px'
  },
  title: {
    margin: 0,
    fontSize: '26px'
  },
  subtitle: {
    margin: '8px 0 0',
    color: '#66788a'
  },
  toolbar: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#fff',
    borderRadius: '8px',
    padding: '14px',
    marginBottom: '18px',
    boxShadow: '0 2px 10px rgba(18, 38, 63, 0.06)'
  },
  input: {
    width: '100%',
    maxWidth: '420px',
    height: '38px',
    border: '1px solid #d6dde5',
    borderRadius: '6px',
    padding: '0 12px',
    fontSize: '14px'
  },
  button: {
    height: '38px',
    border: 0,
    borderRadius: '6px',
    padding: '0 14px',
    background: '#4f6fed',
    color: '#fff',
    fontWeight: 700,
    cursor: 'pointer'
  },
  secondaryButton: {
    height: '34px',
    border: '1px solid #4f6fed',
    borderRadius: '6px',
    padding: '0 12px',
    background: '#fff',
    color: '#4f6fed',
    fontWeight: 700,
    cursor: 'pointer'
  },
  card: {
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(18, 38, 63, 0.06)',
    overflow: 'hidden',
    marginBottom: '18px'
  },
  tableWrap: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '980px'
  },
  th: {
    textAlign: 'left',
    padding: '12px 14px',
    background: '#4f6fed',
    color: '#fff',
    fontSize: '13px',
    whiteSpace: 'nowrap'
  },
  td: {
    padding: '11px 14px',
    borderBottom: '1px solid #edf1f5',
    fontSize: '13px',
    verticalAlign: 'top'
  },
  status: {
    background: '#fff',
    borderRadius: '8px',
    padding: '18px',
    color: '#66788a',
    boxShadow: '0 2px 10px rgba(18, 38, 63, 0.06)',
    marginBottom: '18px'
  },
  error: {
    background: '#fff3f3',
    color: '#b42318',
    border: '1px solid #ffd3d0',
    borderRadius: '8px',
    padding: '14px',
    marginBottom: '18px'
  },
  summary: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(160px, 1fr))',
    gap: '12px',
    marginBottom: '18px'
  },
  summaryItem: {
    background: '#fff',
    borderRadius: '8px',
    padding: '14px',
    boxShadow: '0 2px 10px rgba(18, 38, 63, 0.06)'
  },
  label: {
    display: 'block',
    color: '#66788a',
    fontSize: '12px',
    marginBottom: '6px'
  },
  amount: {
    fontSize: '20px',
    fontWeight: 700
  }
};

const getField = (obj, fieldNames) => {
  if (!obj || typeof obj !== 'object') return undefined;

  for (const fieldName of fieldNames) {
    if (Object.prototype.hasOwnProperty.call(obj, fieldName)) {
      return obj[fieldName];
    }
  }

  const normalizedFields = Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] = obj[key];
    return acc;
  }, {});

  for (const fieldName of fieldNames) {
    const value = normalizedFields[fieldName.toLowerCase()];
    if (value !== undefined) return value;
  }

  return undefined;
};

const money = (value) => {
  const number = Number(value || 0);
  return `Q ${number.toFixed(2)}`;
};

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('es-GT');
};

const getDatosGenerados = (response) => {
  return getField(response, [
    'Datos_Generados',
    'datos_Generados',
    'datos_generados',
    'DatosGenerados',
    'datosGenerados'
  ]) || getField(response?.Metodo, [
    'Datos_Generados',
    'datos_Generados',
    'datos_generados',
    'DatosGenerados',
    'datosGenerados'
  ]) || getField(response?.metodo, [
    'Datos_Generados',
    'datos_Generados',
    'datos_generados',
    'DatosGenerados',
    'datosGenerados'
  ]);
};

const parseGeneratedData = (response) => {
  const generated = getDatosGenerados(response);

  console.log('Datos_Generados detectado:', generated);

  if (!generated) return [];

  try {
    const parsed = typeof generated === 'string' ? JSON.parse(generated) : generated;
    console.log('Datos_Generados parseado:', parsed);

    if (Array.isArray(parsed?.RESP)) return parsed.RESP;
    if (Array.isArray(parsed?.resp)) return parsed.resp;
    if (Array.isArray(parsed)) return parsed;

    return [];
  } catch (error) {
    console.error('Error parseando Datos_Generados:', error);
    return [];
  }
};

const ejecutarGastore = async (datosRecibidos, etiqueta = 'Operacion') => {
  const payload = {
    Token: TOKEN,
    Ambiente: 'DESA',
    Dispositivo: {
      Marca: 'WEB',
      Modelo: 'React',
      Version: '1.0',
      McAdress: null,
      PowerStatus: '100%',
      WifiStatus: 'Connected',
      GPSStatus: 'OFF',
      GPS: ''
    },
    User: {
      Codigo: '0',
      UserNickName: 'pierril'
    },
    Metodo: {
      NombreMetodo: 'CargaArchivoGastore',
      Datos_Recibidos: JSON.stringify(datosRecibidos),
      Datos_Generados: ''
    }
  };

  console.log(`[${etiqueta}] Payload enviado a API:`, payload);
  console.log(`[${etiqueta}] Datos_Recibidos enviado:`, payload.Metodo.Datos_Recibidos);

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const text = await response.text();

  console.log(`[${etiqueta}] HTTP status:`, response.status);
  console.log(`[${etiqueta}] Texto crudo API:`, text);

  if (!response.ok) {
    throw new Error(`Error HTTP ${response.status}: ${text}`);
  }

  try {
    const json = JSON.parse(text);
    console.log(`[${etiqueta}] JSON API parseado:`, json);
    return json;
  } catch (error) {
    console.error(`[${etiqueta}] La API no devolvio JSON valido:`, error);
    throw new Error('La API no devolvio JSON valido');
  }
};

const ListadoConsumoCombustible = () => {
  const [archivos, setArchivos] = useState([]);
  const [detalle, setDetalle] = useState([]);
  const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [error, setError] = useState('');

  const cargarArchivos = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await ejecutarGastore(
        {
          Tabla: 'fd_fact_gas',
          TipoOperacion: 'SelectAll'
        },
        'SelectAll'
      );

      console.log('Respuesta SelectAll completa:', response);

      const data = parseGeneratedData(response);

      console.log('Data parseada SelectAll:', data);

      setArchivos(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error cargando SelectAll:', err);
      setError(err.message);
      setArchivos([]);
    } finally {
      setLoading(false);
    }
  };

  const cargarDetalle = async (archivo) => {
    setArchivoSeleccionado(archivo);
    setDetalle([]);
    setLoadingDetalle(true);
    setError('');

    try {
      const idEncabezado = getField(archivo, ['IdEncabezado', 'idEncabezado']);

      const response = await ejecutarGastore(
        {
          Tabla: 'fd_fact_gas',
          TipoOperacion: 'SelectDetalle',
          IdEncabezado: idEncabezado
        },
        'SelectDetalle'
      );

      console.log('Respuesta SelectDetalle completa:', response);

      const data = parseGeneratedData(response);

      console.log('Data parseada SelectDetalle:', data);

      setDetalle(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error cargando SelectDetalle:', err);
      setError(err.message);
      setDetalle([]);
    } finally {
      setLoadingDetalle(false);
    }
  };

  useEffect(() => {
    cargarArchivos();
  }, []);

  const archivosFiltrados = useMemo(() => {
    const term = busqueda.trim().toLowerCase();
    if (!term) return archivos;

    return archivos.filter((archivo) => {
      const id = String(getField(archivo, ['IdEncabezado', 'idEncabezado']) || '');
      const nombre = String(getField(archivo, ['NombreArchivo', 'nombreArchivo']) || '').toLowerCase();
      const fecha = String(getField(archivo, ['FechaInformacion', 'fechaInformacion']) || '').toLowerCase();

      return id.includes(term) || nombre.includes(term) || fecha.includes(term);
    });
  }, [archivos, busqueda]);

  const resumenDetalle = useMemo(() => {
    return detalle.reduce(
      (acc, row) => ({
        registros: acc.registros + 1,
        totalVentas: acc.totalVentas + Number(getField(row, ['TotalVenta', 'totalVenta']) || 0),
        totalIVA: acc.totalIVA + Number(getField(row, ['IVATotal', 'ivaTotal']) || 0),
        totalIDP: acc.totalIDP + Number(getField(row, ['IDPTotal', 'idpTotal']) || 0)
      }),
      { registros: 0, totalVentas: 0, totalIVA: 0, totalIDP: 0 }
    );
  }, [detalle]);

  return (
    <div style={pageStyles.container}>
      <div style={pageStyles.wrapper}>
        <header style={pageStyles.header}>
          <h1 style={pageStyles.title}>Listado de Cargas de Combustible</h1>
          <p style={pageStyles.subtitle}>Consulta de archivos cargados y detalle de ventas.</p>
        </header>

        {error && <div style={pageStyles.error}>{error}</div>}

        <div style={pageStyles.toolbar}>
          <input
            style={pageStyles.input}
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar por archivo, fecha o ID..."
          />
          <button style={pageStyles.button} type="button" onClick={cargarArchivos} disabled={loading}>
            {loading ? 'Cargando...' : 'Actualizar'}
          </button>
        </div>

        {loading && <div style={pageStyles.status}>Cargando archivos...</div>}

        <section style={pageStyles.card}>
          <div style={pageStyles.tableWrap}>
            <table style={pageStyles.table}>
              <thead>
                <tr>
                  <th style={pageStyles.th}>ID</th>
                  <th style={pageStyles.th}>Archivo</th>
                  <th style={pageStyles.th}>Fecha Informacion</th>
                  <th style={pageStyles.th}>Fecha Carga</th>
                  <th style={pageStyles.th}>Registros</th>
                  <th style={pageStyles.th}>Total Ventas</th>
                  <th style={pageStyles.th}>IVA</th>
                  <th style={pageStyles.th}>IDP</th>
                  <th style={pageStyles.th}>Accion</th>
                </tr>
              </thead>
              <tbody>
                {archivosFiltrados.map((archivo) => {
                  const idEncabezado = getField(archivo, ['IdEncabezado', 'idEncabezado']);
                  const nombreArchivo = getField(archivo, ['NombreArchivo', 'nombreArchivo']);
                  const fechaInformacion = getField(archivo, ['FechaInformacion', 'fechaInformacion']);
                  const fechaCarga = getField(archivo, ['FechaCarga', 'fechaCarga']);
                  const totalRegistros = getField(archivo, ['TotalRegistros', 'totalRegistros']);
                  const totalVentas = getField(archivo, ['TotalVentas', 'totalVentas']);
                  const totalIVA = getField(archivo, ['TotalIVA', 'totalIVA']);
                  const totalIDP = getField(archivo, ['TotalIDP', 'totalIDP']);

                  return (
                    <tr key={idEncabezado}>
                      <td style={pageStyles.td}>{idEncabezado}</td>
                      <td style={pageStyles.td}>{nombreArchivo}</td>
                      <td style={pageStyles.td}>{fechaInformacion}</td>
                      <td style={pageStyles.td}>{formatDate(fechaCarga)}</td>
                      <td style={pageStyles.td}>{totalRegistros || 0}</td>
                      <td style={pageStyles.td}>{money(totalVentas)}</td>
                      <td style={pageStyles.td}>{money(totalIVA)}</td>
                      <td style={pageStyles.td}>{money(totalIDP)}</td>
                      <td style={pageStyles.td}>
                        <button style={pageStyles.secondaryButton} type="button" onClick={() => cargarDetalle(archivo)}>
                          Ver Detalle
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>

        {!loading && archivosFiltrados.length === 0 && (
          <div style={pageStyles.status}>No hay cargas para mostrar. Revise la consola para ver la respuesta de la API.</div>
        )}

        {archivoSeleccionado && (
          <>
            <div style={pageStyles.summary}>
              <div style={pageStyles.summaryItem}>
                <span style={pageStyles.label}>Archivo</span>
                <strong>{getField(archivoSeleccionado, ['NombreArchivo', 'nombreArchivo'])}</strong>
              </div>
              <div style={pageStyles.summaryItem}>
                <span style={pageStyles.label}>Registros</span>
                <span style={pageStyles.amount}>{resumenDetalle.registros}</span>
              </div>
              <div style={pageStyles.summaryItem}>
                <span style={pageStyles.label}>Total Ventas</span>
                <span style={pageStyles.amount}>{money(resumenDetalle.totalVentas)}</span>
              </div>
              <div style={pageStyles.summaryItem}>
                <span style={pageStyles.label}>IVA + IDP</span>
                <span style={pageStyles.amount}>{money(resumenDetalle.totalIVA + resumenDetalle.totalIDP)}</span>
              </div>
            </div>

            {loadingDetalle && <div style={pageStyles.status}>Cargando detalle...</div>}

            <section style={pageStyles.card}>
              <div style={pageStyles.tableWrap}>
                <table style={pageStyles.table}>
                  <thead>
                    <tr>
                      <th style={pageStyles.th}>Fecha</th>
                      <th style={pageStyles.th}>Tipo Doc.</th>
                      <th style={pageStyles.th}>No. Documento</th>
                      <th style={pageStyles.th}>NIT</th>
                      <th style={pageStyles.th}>Nombre</th>
                      <th style={pageStyles.th}>Producto</th>
                      <th style={pageStyles.th}>Cantidad</th>
                      <th style={pageStyles.th}>Precio Unit.</th>
                      <th style={pageStyles.th}>Total Venta</th>
                      <th style={pageStyles.th}>IVA</th>
                      <th style={pageStyles.th}>IDP</th>
                      <th style={pageStyles.th}>Tipo Pago</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalle.map((row, index) => {
                      const idDetalle = getField(row, ['IdDetalle', 'idDetalle']) || index;
                      const fechaEmision = getField(row, ['FechaEmision', 'fechaEmision']);
                      const tipoDocumento = getField(row, ['TipoDocumento', 'tipoDocumento']);
                      const noDocumento = getField(row, ['NoDocumento', 'noDocumento']);
                      const nit = getField(row, ['NIT', 'nit']);
                      const nombre = getField(row, ['Nombre', 'nombre']);
                      const producto = getField(row, ['Producto', 'producto']);
                      const cantidad = getField(row, ['Cantidad', 'cantidad']);
                      const precioUnitario = getField(row, ['PrecioUnitario', 'precioUnitario']);
                      const totalVenta = getField(row, ['TotalVenta', 'totalVenta']);
                      const ivaTotal = getField(row, ['IVATotal', 'ivaTotal']);
                      const idpTotal = getField(row, ['IDPTotal', 'idpTotal']);
                      const tipoPago = getField(row, ['TipoPago', 'tipoPago']);

                      return (
                        <tr key={idDetalle}>
                          <td style={pageStyles.td}>{formatDate(fechaEmision)}</td>
                          <td style={pageStyles.td}>{tipoDocumento}</td>
                          <td style={pageStyles.td}>{noDocumento}</td>
                          <td style={pageStyles.td}>{nit}</td>
                          <td style={pageStyles.td}>{nombre}</td>
                          <td style={pageStyles.td}>{producto}</td>
                          <td style={pageStyles.td}>{cantidad}</td>
                          <td style={pageStyles.td}>{money(precioUnitario)}</td>
                          <td style={pageStyles.td}>{money(totalVenta)}</td>
                          <td style={pageStyles.td}>{money(ivaTotal)}</td>
                          <td style={pageStyles.td}>{money(idpTotal)}</td>
                          <td style={pageStyles.td}>{tipoPago}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>

            {!loadingDetalle && detalle.length === 0 && (
              <div style={pageStyles.status}>No hay detalle para este archivo. Revise la consola para ver la respuesta de la API.</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ListadoConsumoCombustible;

